import { HttpClient } from '@angular/common/http';
import { AfterContentInit, Component } from '@angular/core';


@Component({
  selector: 'app-funding-category-lookup',
  templateUrl: './funding-category-lookup.component.html',
  styleUrls: ['./funding-category-lookup.component.css']
})
export class FundingCategoryLookupComponent implements AfterContentInit {

  fundingCodes: { code: string, description: string }[];
  urlCode = '';

  constructor(private http: HttpClient) {
  }

  async ngAfterContentInit() {
    await this.getFundingCodes();

    setTimeout(function () {
      const url = window.location.href;
      if (url.includes('#')) {
        this.urlCode = url.substring(url.indexOf('#') + 1, url.length);
        const a = document.getElementById(this.urlCode);
        a.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 500);
  }

  async getFundingCodes() {
    const requestURL = 'api/reports/GetFundingCodes';

    try {
      this.fundingCodes = (await this.http.get<{ code: string, description: string }[]>(requestURL).toPromise());

    } catch (error) {
      console.error('Error', error);
    }
  }
}
